import { render, staticRenderFns } from "./ShareViews.vue?vue&type=template&id=050592fe"
import script from "./ShareViews.vue?vue&type=script&lang=js"
export * from "./ShareViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports